import {  AjaxObservable, AjaxCreationMethod  } from './AjaxObservable';

export const ajax: AjaxCreationMethod = AjaxObservable.create;


// WEBPACK FOOTER //
// ../../../src/observable/dom/ajax.ts